import React from 'react';



type Props = {
  className?: string;
};
export const ExpandMoreVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns='http://www.w3.org/2000/svg'>
      <path fill = '#0041A0' d = 'M8 6.645L12.9447 12L8 17.355L9.52227 19L16 12L9.52227 5L8 6.645Z' />
    </svg>
  );
};


